module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h1', [_c('span', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }]
  }, [_vm._v("Lista de medicações para")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("date")(_vm.date, "DD/MM/YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('ul', {
    staticClass: "list-unstyled list-inline text-right"
  }, [_c('li', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle font-red",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-grey-cascade"
  }, [_vm._v("Medicação atrasada")])]), _vm._v(" "), _c('li', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-check font-green",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-grey-cascade"
  }, [_vm._v("Medicação ministrada")])]), _vm._v(" "), _c('li', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-ban font-red",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "translate",
      rawName: "v-translate"
    }],
    staticClass: "font-grey-cascade"
  }, [_vm._v("Medicação rejeitada")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2488f10b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./sources/domains/medicine/medicine-labels/medicine-labels.vue
// module id = 1046
// module chunks = 1